export const SOURCES = {
  POLICY_MANAGEMENT: 'policy-management',
}

export const BASE_USERS = [{ label: 'Guests / External Users', value: 'GuestsOrExternalUsers' }]

export const BASE_INCLUDE_USERS = [
  { label: 'All users', value: 'All' },
  { label: 'No users', value: 'None' },
  ...BASE_USERS,
]

export const BASE_LOCATIONS = [{ label: 'All trusted locations', value: 'AllTrusted' }]

export const BASE_INCLUDE_LOCATIONS = [{ label: 'All', value: 'All' }, ...BASE_LOCATIONS]

export const BASE_APPLICATIONS = [
  { label: 'Office 365', value: 'Office365' },
  { label: 'Microsoft Admin Portals', value: 'MicrosoftAdminPortals' },
]

const MICROSOFT_INTUNE_APPLICATION = {
  label: 'Microsoft Intune',
  value: '0000000a-0000-0000-c000-000000000000',
}

// The app Conditional Access targets to control device enrollment, as used by CIS M365 v6 5.2.2.11.
const MICROSOFT_INTUNE_ENROLLMENT_APPLICATION = {
  label: 'Microsoft Intune Enrollment',
  value: 'd4ebce55-015a-49b5-a083-c84d1797ae8c',
}

const AZURE_WINDOWS_VM_SIGN_IN_APPLICATION = {
  label: 'Azure Windows VM Sign-In',
  value: '372140e0-b3b7-4226-8ef9-d57986796201',
}

const AZURE_MANAGEMENT_APPLICATION = {
  label: 'Windows Azure Service Management API',
  value: '797f4846-ba00-4fd7-ba43-dac1f8f63013',
}

export const KNOWN_MICROSOFT_APPLICATIONS = [
  MICROSOFT_INTUNE_APPLICATION,
  MICROSOFT_INTUNE_ENROLLMENT_APPLICATION,
  AZURE_WINDOWS_VM_SIGN_IN_APPLICATION,
  AZURE_MANAGEMENT_APPLICATION,
]

export const BASE_INCLUDE_APPLICATIONS = [
  { label: 'None', value: 'None' },
  { label: 'All', value: 'All' },
  ...BASE_APPLICATIONS,
]

export const DEFAULT_EMPTY_POLICY = {
  state: 'enabledForReportingButNotEnforced',
  conditions: {
    users: {
      includeUsers: ['None'],
    },
    applications: {
      includeApplications: ['None'],
    },
    clientAppTypes: ['all'],
  },
  grantControls: {
    operator: 'AND',
    builtInControls: ['mfa'],
  },
}

export const POLICY_STATE_REPORT = 'enabledForReportingButNotEnforced'
